import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'leave',
  templateUrl: 'leave.component.html',
  standalone: false
})
export class LeaveComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {
    document.querySelector('body').classList.remove('opened');
  }
}
